import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  provideTranslationDictionaryMapping,
  TranslatePipe,
  TranslateService,
} from '@i18n';
import { ButtonComponent } from '../button/button.component';
import { IconListComponent } from '../icon-list/icon-list.component';
import { IconListItem } from '../icon-list/models/icon-list-item.interface';
import { IconComponent } from '../icon/icon.component';
import { FeatureRegisterAnotherApplianceTranslationDictionary } from './i18n/feature-register-another-appliance-dictionary.interface';
import { translation } from './i18n/translation.constant';

@Component({
  selector: 'app-register-another-appliance',
  templateUrl: './register-another-appliance.component.html',
  styleUrl: './register-another-appliance.component.scss',
  imports: [ButtonComponent, IconComponent, IconListComponent, TranslatePipe],
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class RegisterAnotherApplianceComponent {
  private readonly router = inject(Router);
  private readonly translateService = inject(
    TranslateService<FeatureRegisterAnotherApplianceTranslationDictionary>,
  );

  readonly iconListItems: IconListItem[] = this.translateService
    .translate('REGISTER_ANOTHER_APPLIANCE_LIST')
    .map((text: string) => ({
      iconName: 'circle-check',
      text,
    }));

  onRegisterAnotherAppliance(): void {
    this.router.navigate(['/']);
  }
}
